import React, { useEffect } from 'react';

import { Box, ButtonBase, Grid, Typography } from '@material-ui/core';

import { ReactComponent as RightIcon } from '../../../../assets/img/icon/Right.svg';
import SuraCard from '../../../../components/SuraCard';
import { incidentRoad } from '../../../../constants/incidents.constant';
import { useSinisterDataContext } from '../../../../context/sinister/sinister.provider';
import Parts from './Parts.component';
import SelectTypeOfDamage from './SelectTypeOfDamage.component';

const SelectRobbery = () => {
  const { nextStep, sinister_body } = useSinisterDataContext();

  let incidentType = incidentRoad[sinister_body.incident_type];

  useEffect(() => {
    let keytodelete = null;
    // TODO: fix this bad assignation
    incidentType = incidentRoad[sinister_body.incident_type];
    incidentType.forEach((element: any, key: any) => {
      if (element?.title === 'Neumáticos robados') {
        keytodelete = key;
      }
      if (element?.title === '¿Qué te robaron?') {
        incidentType.splice(key, 1);
      }
    });
    if (keytodelete) incidentType.splice(keytodelete, 1);

    incidentType = incidentType.sort((a: any, b: any) =>
      a.order > b.order ? 1 : -1
    );
    incidentType = incidentRoad[sinister_body.incident_type];
  }, []);

  const breakInStep = {
    title: '¿Qué te robaron?',
    content: <Parts />,
    order: sinister_body?.robbery?.type === 'total' ? 7 : 6,
  };

  const other = {
    title: 'Daños en mi vehículo',
    content: <SelectTypeOfDamage />,
    order: sinister_body?.robbery?.type === 'total' ? 10 : 3,
  };

  const selectCard = (breakIn: boolean) => {
    let keytodelete = null;
    incidentType = incidentRoad[sinister_body.incident_type];

    if (breakIn) {
      if (
        !incidentType.find(
          (element: { title: any }) => element?.title === '¿Qué te robaron?'
        )
      ) {
        incidentType.push(breakInStep);
      } else {
        incidentType.forEach((element: any, key: any) => {
          if (element?.title === 'Neumáticos robados') {
            incidentType.splice(key, 1);
          }
        });
      }
    }
    if (breakIn === false && sinister_body.incident_type !== 'damage') {
      incidentType.forEach((element: any, key: any) => {
        if (element?.title === '¿Qué te robaron?') {
          incidentType.splice(key, 1);
        }
        if (element?.title === 'Neumáticos robados') {
          incidentType.splice(key, 1);
        }
      });
      if (
        !incidentType.find(
          (element: { title: any }) => element?.title === 'Daños en mi vehículo'
        )
      ) {
        incidentType.push(other);
      }
    }

    if (keytodelete) incidentType.splice(keytodelete, 1);

    incidentType = incidentType.sort((a: any, b: any) =>
      a.order > b.order ? 1 : -1
    );
    incidentType = incidentRoad[sinister_body.incident_type];

    nextStep();
  };

  return (
    <Grid item xs={12} sm={6}>
      <Box>
        <Box my={4}>
          <Typography variant="h6" color="textPrimary">
            ¿Sufriste algún robo?
          </Typography>
        </Box>
        <Box mr={3} mb={3}>
          <ButtonBase
            style={{ width: '100%' }}
            onClick={() => selectCard(true)}
          >
            <SuraCard
              // className={
              //   sinister_body[relatedField] === card.value
              //     ? classes.selectedCard
              //     : ""
              // }
              style={{ width: '100%' }}
            >
              <Box
                m={3}
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                width={'100%'}
              >
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Box ml={1}>
                    <Typography variant="body1">Sí, me robaron</Typography>
                  </Box>
                </Box>
                <Box>
                  <RightIcon></RightIcon>
                </Box>
              </Box>
            </SuraCard>
          </ButtonBase>
        </Box>

        <Box mr={3} mb={3}>
          <ButtonBase
            style={{ width: '100%' }}
            onClick={() => selectCard(false)}
          >
            <SuraCard
              // className={
              //   sinister_body[relatedField] === card.value
              //     ? classes.selectedCard
              //     : ""
              // }
              style={{ width: '100%' }}
            >
              <Box
                m={3}
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                width={'100%'}
              >
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Box ml={1}>
                    <Typography variant="body1">No me robaron</Typography>
                  </Box>
                </Box>
                <Box>
                  <RightIcon></RightIcon>
                </Box>
              </Box>
            </SuraCard>
          </ButtonBase>
        </Box>
      </Box>
    </Grid>
  );
};

export default SelectRobbery;
